<template>
  <div class="mb-2 border text-sm text-gray-800 hover:shadow-lg" :class="{ 'shadow-lg': isOpen }">
    <div class="px-4 py-3">
      <div class="flex">
        <div
          class="font-semibold flex-1"
          :class="{ 'cursor-pointer': !isOpen }"
          @click="isOpen = true"
        >
          <div class="leading-relaxed">{{ person.firstname }} {{ person.lastname }}</div>
          <div v-if="person.job_title" class="font-normal text-gray-600">{{ person.job_title }}</div>
        </div>
        <BaseDropdown icon="more-vertical" button-class="btn-icon">
          <router-link
            :to="{ name: 'people.edit', params: { id: person.id } }"
            class="dropdown-item w-32"
          >Wijzigen</router-link>
          <DeleteConfirmButton
            class="dropdown-item w-32"
            :message="`Weet je zeker dat je deze persoon wilt verwijderen?`"
            @confirm="deletePerson()"
          >Verwijderen</DeleteConfirmButton>
        </BaseDropdown>
      </div>
    </div>
    <div v-if="isOpen">
      <div class="px-4 py-3 border-t border-gray-200">
        <div class="flex items-center justify-between">
          <div class="text-gray-500">Contactgegevens</div>
          <button type="button" @click="isOpen = false">
            <BaseIcon name="x" />
          </button>
        </div>
      </div>
      <div class="px-4 py-3 border-t border-gray-200">
        <PersonDetails :person="person" class="mt-1" />
      </div>
    </div>
    <router-link
      v-if="person.contact_id"
      :to="{ name: 'contacts.show', params: { id: person.contact_id } }"
      class="px-4 py-3 flex items-center justify-between bg-blue-100 text-blue-600"
    >
      Bekijk particulier dossier
      <BaseIcon name="arrow-right" size="16" />
    </router-link>
  </div>
</template>

<script>
import { destroy } from "@/api.js";
import PersonDetails from "./PersonDetails";
import DeleteConfirmButton from "./DeleteConfirmButton";

export default {
  props: {
    person: Object
  },

  components: {
    PersonDetails,
    DeleteConfirmButton
  },

  data() {
    return {
      isOpen: false
    };
  },

  methods: {
    deletePerson() {
      let organizationId = this.$store.state.contact.contact.id;
      let name = this.person.firstname;

      destroy(`/organizations/${organizationId}/people/${this.person.id}`).then(
        response => {
          this.$store.commit("SET_CONTACT", response.data);
          this.$store.commit("FLASH_ADD", { message: `${name} is verwijderd uit dossier` });
        }
      );
    }
  }
};
</script>
